module.exports = __webpack_public_path__ + "static/media/dansketext-semibold.8d3afba9.eot";